<template>
  <div class="container" id="container">
    <div class="top-banner">
      <div v-if="recruitType === 0" class="banner-video">
        <Video class="video"></Video>
      </div>
      <div v-else class="banner-img">
        <img class="banner" src="../../../assets/images/jobs/banner.png" alt="">
      </div>
    </div>

    <!-- 50px 转换为vw 13.333vw -->
    <!-- todo 上滑背景框； -->
    <!-- 搜索框 -->
    <van-sticky offset-top="13.333333vw" class="sticky-area">
      <form action="/">
        <van-search v-model="searchInput" class="search-box" @search="onSearch" @input="onSearchInput" placeholder="搜索职位">
          <template #left-icon>
            <icon-svg class="icon-search" name="search"></icon-svg>
          </template>
        </van-search>
      </form>

      <!-- 条件选择框 -->
      <div class="condition-box">
        <van-dropdown-menu active-color="#2E5DD2">
          <van-dropdown-item ref="locationDropdown" title="工作地点" @open="onOpenLocationPanel" @closed="onLocationPanelClosed" :title-class="locationSelected.length === 0 ? '' : 'active' ">
            <select-panel ref="locationSelect" :options="locationOptions" @onConfirm="onLocationSelected"></select-panel>
          </van-dropdown-item>

          <van-dropdown-item ref="positionDropdown" title="职位类别" @closed="onPositionPanelClosed" :title-class="positionSelected.length === 0 ? '' : 'active' ">
            <select-panel ref="positionSelect" :options="workTypeOptions" @onConfirm="onPositionSelected"></select-panel>
          </van-dropdown-item>

          <van-dropdown-item v-model="recruitType" title-class="active" :options="recruitTypeOptions" @change="onRecruitTypeChange" />
        </van-dropdown-menu>
      </div>
    </van-sticky>

    <!-- 职位列表 -->
    <div class="job-list">
      <van-empty v-show="showEmpty">
        未搜索到匹配岗位
        <template #image>
          <img class="empty-image" src="../../../assets/images/common/empty.png" alt="no-jobs">
        </template>
      </van-empty>
      <van-list v-model="loading" :finished="finished" :error.sync="error" :error-text="errorText" loading-text="加载中..." :finished-text="finishedText" @load="onGetMore">
        <div v-for="(job, i) in jobList" :key="i" class="job-card" @click="showJobPopup(job)">
          <div class="top">
            <div class="job-title ellipsis line1">{{ job.name }}</div>
            <div class="time">{{ job.updatetime | formatDate_ }}</div>
          </div>
          <div class="labels">
            <div class="label">{{ job.work_city }}</div>
            <div class="label">{{ job.education | educationText}}</div>
            <div class="label">{{ job.work_type | workTypeText}}</div>
          </div>
        </div>
      </van-list>
    </div>

    <van-popup v-model="jobPopupVisible" get-container="body" position="bottom" class="popup" closeable round
      :close-on-click-overlay="true" :close-on-popstate="true" :lazy-render=false :lock-scroll="true">
      <job-detail isPopup="true" ref="detailPopup"></job-detail>
    </van-popup>
  </div>
</template>

<script>
import Video from "@/components/Video";
import SelectPanel from "@/components/SelectPanel";
import JobDetail from "../detail";

import { mapState } from "vuex";
import { debounce, sortBy, isEqual } from "lodash";
import util from "../../../libs/util";

export default {
  name: "JobList",
  components: {
    Video,
    SelectPanel,
    JobDetail,
  },
  data() {
    return {
      errorText: "网络开小差了，点击重新加载",
      jobList: [],
      searchInput: "",
      searchKeyword: "",
      // 0 社招 1 校招
      recruitType: 0,
      recruitTypeOptions: [
        { text: "社会招聘", value: 0 },
        { text: "校园招聘", value: 1 },
      ],
      // 工作地点
      locationOptions: [],
      locationSelected: "",
      positionSelected: "",
      jobPopupVisible: false,
      listPage: 1,
      loading: false,
      finished: false,
      error: false,
    };
  },
  computed: {
    ...mapState("dic", ["workTypeList"]),
    // 职位类型
    workTypeOptions() {
      return this.workTypeList.map((item) => {
        return {
          text: item.text,
          key: item.key,
        };
      });
    },
    recruitment_type() {
      return this.recruitType === 0 ? "SOCIAL" : "SCHOOL";
    },
    showEmpty() {
      return !this.error && !this.loading && this.jobList.length === 0;
    },
    finishedText() {
      return this.jobList.length === 0 ? "" : "— 到底咯！—";
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler: function (newPath, oldPath) {
        if (newPath !== oldPath) {
          const container = document.getElementById("container");
          if (container) {
            container.scrollTop = 0;
          }
          this.recruitType = this.$route.meta.type === "social" ? 0 : 1;
          this.refreshJobList();
        }
      },
    },
  },
  created() {
    this.getWorkCities();
    this.debounceSearch = debounce(this.onSearch, 500);
  },
  mounted() {
    if (this.recruitType === 0) {
      const shareParam = {
        title: "卫宁健康期待您的加入",
        desc: "正在热招",
        link: process.env.VUE_APP_BASEURL +'#/job/list/social',
        imgUrl: process.env.VUE_APP_SHARE_IMG_URL
      }
      util.initWXSdk(shareParam)
    }else{
      const shareParam = {
        title: "加入我们，实现价值",
        desc: "卫宁健康2027校园招聘",
        link:  process.env.VUE_APP_BASEURL +'/#/job/list/campus',
        imgUrl: process.env.VUE_APP_SHARE_IMG_URL
      }
      util.initWXSdk(shareParam)
    }
  },
  methods: {
    // 重新获取职位列表
    refreshJobList() {
      // 清空列表数据
      this.jobList = [];
      this.finished = false;
      this.listPage = 1;
      this.getJobList();
    },

    // 获取更多数据
    onGetMore() {
      // 分页更新
      this.listPage += 1;
      this.getJobList();
    },

    // 获取一页数据
    getJobList() {
      this.loading = true;
      const params = {
        status: "Online",
        recruitment_type: this.recruitment_type,
        name: this.searchKeyword,
        work_types: this.positionSelected,
        work_citys: this.locationSelected,
        page: this.listPage,
        size: 10,
      };

      this.$api
        .GET_POSITION_LIST(params)
        .then((res) => {
          this.jobList = this.jobList.concat(res.content);
          // 数据全部加载完成
          if (res.total <= this.listPage * 10) {
            this.finished = true;
          }
          this.error = false;
        })
        .catch(() => {
          this.error = true;
          this.listPage -= 1;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取工作地点列表
    getWorkCities() {
      this.$api.GET_WORKCITY_LIST().then((res) => {
        this.locationOptions = res.map((item) => {
          return {
            text: item,
            key: item,
          };
        });
      });
    },

    // 搜索
    onSearch() {
      this.searchKeyword = this.searchInput;
      this.refreshJobList();
    },

    // 输入框内容更改后做搜索
    onSearchInput() {
      // 防抖设置
      this.debounceSearch();
    },

    // 职位类型选择改变
    onLocationSelected(selectedValues) {
      this.$refs["locationDropdown"].toggle();
      this.locationSelected = selectedValues.join(",");
      this.refreshJobList();
    },

    // 职位类型下拉框关闭（判断选项是否有改变，改变->重新获取列表）
    onLocationPanelClosed() {
      let newSelectedValues =
        this.$refs["locationSelect"].selectedValues.join(",");
      if (!isEqual(sortBy(newSelectedValues), sortBy(this.locationSelected))) {
        this.locationSelected = newSelectedValues;
        this.refreshJobList();
      }
    },

    // 工作地点选择改变
    onPositionSelected(selectedValues) {
      this.$refs["positionDropdown"].toggle();
      this.positionSelected = selectedValues.join(",");
      this.refreshJobList();
    },

    // 工作地点下拉框关闭（判断选项是否有改变，改变->重新获取列表）
    onPositionPanelClosed() {
      let newSelectedValues =
        this.$refs["positionSelect"].selectedValues.join(",");
      if (!isEqual(sortBy(newSelectedValues), sortBy(this.positionSelected))) {
        this.positionSelected = newSelectedValues;
        this.refreshJobList();
      }
    },

    // 改变招聘类型(切换页面)
    onRecruitTypeChange() {
      this.$router.push({
        path: `/job/list/${this.recruitType === 0 ? "social" : "campus"}`,
      });
    },

    // 展示职位详情下拉面板
    showJobPopup(job) {
      this.$refs["detailPopup"].jobId = job.id;
      this.$refs["detailPopup"].refreshJobDetail(true);
      this.jobPopupVisible = true;
    },
    // 打开位置面板时，若未取得到，则重新获取
    onOpenLocationPanel() {
      if (!this.locationOptions || this.locationOptions.length === 0) {
        this.getWorkCities();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 50px);
  overflow-y: scroll;
  background: white;
}

.top-banner {
  background: #2e5dd2;
  height: 210px;
  .banner-video {
    width: 100%;
    height: 210px;
    background: #2e5dd2;
    z-index: 10;
    overflow: hidden;

    .video {
      overflow: hidden;
      // border-radius: 15px 15px 0 0;
    }
  }

  .banner-img img {
    height: 210px;
  }
}

.sticky-area {
  background: #ffffff;

  ::v-deep .van-search {
    padding: 10px 15px;
    display: flex;

    .van-search__content {
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 22px;
      border: 1px solid #eaedf0;
    }
    .van-search__content .van-cell {
      margin-top: 2px;
    }

    .van-field__left-icon {
      display: flex;
      align-items: center;
    }
  }

  .icon-search {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .condition-box {
    /* 下拉菜单 */
    ::v-deep {
      .van-dropdown-menu__item {
        background-color: white !important;
      }
      .van-dropdown-item__content {
        border-radius: 0px 0px 15px 15px;
      }
      .van-dropdown-menu__bar {
        box-shadow: none;
        height: 44px;
      }
      .van-dropdown-menu__title {
        font-size: 14px;
        background-color: white !important;
        opacity: 1;
      }
      .van-dropdown-menu__title::after {
        opacity: 1;
        background-image: url(../../../assets/images/common/arrow-down.png) !important;
        background-color: white !important;
        border: none;
        content: "";
        background-size: 8px 5px;
        transform: none;
        width: 8px;
        height: 5px;
        top: calc(50% - 3px);
        margin-top: 0;
      }
      /* 有筛选时的标题 */
      .van-dropdown-menu__title.active {
        color: #2e5dd2;
      }
      .van-dropdown-menu__title.active::after {
        opacity: 1;
        background-color: white !important;
        background-image: url(../../../assets/images/common/arrow-down-blue.png) !important;
      }
      .van-dropdown-menu__title--down::after {
        opacity: 1;
        background-color: white !important;
        background-image: url(../../../assets/images/common/arrow-up-blue.png) !important;
      }
    }
  }
}

.job-list {
  .job-card {
    margin: 0px 20px;
    padding: 12px 0 19px 0;
    border-bottom: 0.5px solid #f1f4f6;
    background: #ffffff;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }
    .job-title {
      font-size: 18px;
      font-weight: bold;
      margin-right: 15px;
    }
    .time {
      color: #999999;
      font-size: 12px;
      min-width: 65px;
    }
    .labels {
      display: flex;
      .label {
        height: 20px;
        padding: 1px 8px 2px 8px;
        margin-right: 5px;
        font-size: 12px;
        color: #999999;
        background: #f1f4f6;
        border-radius: 4px;
      }
      .label:nth-child(1) {
        max-width: 130px;
      }
    }
  }
  ::v-deep .van-empty__image {
    width: 216px;
    /* height: 150px; */
  }

  ::v-deep .van-empty__image img {
    width: 216px;
    height: 150px;
  }

  ::v-deep .van-empty__bottom {
    color: #999999;
    font-size: 14px;
  }

  ::v-deep .van-list__finished-text {
    color: #cccccc;
  }
}
::v-deep .van-popup__close-icon--top-right {
  top: 24px;
}
</style>
